export default "__VITE_ASSET__c275d61f__"